import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import "react-responsive-modal/styles.css";
import "../style.css";
import { CommonStyle, CommonHeaderStyle } from "../Utility/utilis";
import EmailPopup from "./EmailPopup";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import swal from "sweetalert";
import { errorToastMessage } from "utils/errorToast";
import {
  deleteEmailConfiguration,
  getEmailConfigurations,
  sendNoticeEmailWithDocuments,
} from "./action";
import NoData from "../Utility/NoData";

export default function Table() {
  const dispatch = useDispatch();
  const emailTableData = useSelector(
    (state) => state.emailConfigReducer.emailTableData
  );
  const selectedGstin = useSelector(
    (state) => state.noticeReducer.selectedGstin
  );
  const [showPopup, setShowPopup] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState({});
  const handleClosePopup = () => setShowPopup(false);

  const handleEdit = (row) => {
    console.log("row::", row);
    setSelectedRow(row);
    setShowPopup(true);
  };

  const handleDelete = async (row) => {
    try {
      const willDelete = await swal({
        title: "Are you sure?",
        text: `Are you sure you want to delete all email configurations for Gstin: ${row.gstin}?`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });

      if (willDelete) {
        const result = await dispatch(deleteEmailConfiguration(row.gstin));
        if (result.success) {
          console.log("Inside result.success::", result.success);
          // Refresh the email configurations after successful deletion
          dispatch(getEmailConfigurations(selectedGstin));
        }
      }
    } catch (error) {
      console.log("Error in handleDelete:", error);
      errorToastMessage("Error while deleting configuration");
    }
  };

  const handleSendEmail = async (row) => {
    try {
      // Validate required data
      if (!row.gstin) {
        errorToastMessage("GSTIN is required to send email");
        return;
      }

      if (!row.email || !Array.isArray(row.email) || row.email.length === 0) {
        errorToastMessage("At least one email address is required");
        return;
      }

      if (
        !row.reference_ids ||
        (!Array.isArray(row.reference_ids) && !row.reference_ids) ||
        (Array.isArray(row.reference_ids) && row.reference_ids.length === 0)
      ) {
        console.log('row.reference_ids ::', row.reference_ids);
        // errorToastMessage("No reference IDs available for this configuration.");
        errorToastMessage('No Documents available to send email.');
        return;
      }

      // Ensure refId is an array
      const refIdArray = Array.isArray(row.reference_ids)
        ? row.reference_ids
        : [row.reference_ids];

      const willSend = await swal({
        title: "Send Notice Emails?",
        text: "Are you sure you want to send notice emails",
        icon: "info",
        buttons: true,
        dangerMode: true,
      });

      if (willSend) {
        const result = await dispatch(
          sendNoticeEmailWithDocuments({
            gstin: row.gstin,
            email: row.email,
            refId: refIdArray,
          })
        );

        if (result.status === "success") {
          console.log("Email request initiated successfully:", result.data);
        }
      }
    } catch (error) {
      console.log("Error in handleSendEmail:", error);
      errorToastMessage("Error while sending email");
    }
  };
  const ActionIcon = (row) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "5px",
          width: "100%",
          justifyContent: "center",
        }}
      >
        <EditOutlinedIcon
          onClick={() => {
            handleEdit(row);
          }}
          style={{
            width: "15px",
            height: "15px",
            cursor: "pointer",
            color: "#00ffd0ff",
          }}
        />
        <DeleteOutlinedIcon
          onClick={() => {
            handleDelete(row);
          }}
          style={{ width: "15px", height: "15px", cursor: "pointer" }}
        />
        <MailOutlineIcon
          onClick={() => {
            handleSendEmail(row);
          }}
          style={{
            width: "15px",
            height: "15px",
            cursor: "pointer",
            color: "#00ffd0ff",
          }}
        />
      </div>
    );
  };

  const columns = [
    {
      dataField: "gstin",
      text: "GSTIN",
      style: (cell, row, rowIndex, colIndex) => CommonStyle(),
      headerStyle: CommonHeaderStyle,
    },
    {
      dataField: "email",
      text: "Email ID",
      style: (cell, row, rowIndex, colIndex) => ({
        ...CommonStyle(),
        textAlign: "center",
        verticalAlign: "middle",
      }),
      headerStyle: CommonHeaderStyle,
      formatter: (cell, row, rowIndex) => {
        if (Array.isArray(cell) && cell.length > 0) {
          return (
            <div style={{ whiteSpace: "pre-line", width: "100%" }}>
              {cell.join("\n")}
            </div>
          );
        }
        return cell || "--";
      },
    },
    {
      dataField: "created_date",
      text: "Date of Creation",
      style: (cell, row, rowIndex, colIndex) => CommonStyle(),
      headerStyle: CommonHeaderStyle,
      formatter: (cell, row, rowIndex) => {
        return row.created_date
          ? moment(row.created_date).format("DD-MM-YYYY HH:mm:ss")
          : "--";
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row, rowIndex) => ActionIcon(row),
      style: (cell, row, rowIndex, colIndex) => CommonStyle(),
      headerStyle: CommonHeaderStyle,
    },
  ];

  return (
    <>
      {emailTableData?.length > 0 ? (
        <div className="light-border-notice-table">
          <BootstrapTable
            keyField="gstin"
            data={emailTableData}
            columns={columns}
          />
          <EmailPopup
            open={showPopup}
            onClose={handleClosePopup}
            isEdit={true}
            selectedRow={selectedRow}
          />
        </div>
      ) : (
        <NoData />
      )}
    </>
  );
}
